<template>
	<div class="entry-content">
		<h2>Users</h2>
		<div class="main-navigation-wrapper">
			<router-link class="nav-item" to="/individuals">
				<div class="navigation-item"></div>
				Individuals
			</router-link>
		</div>
		<h2>Content</h2>
		<div class="main-navigation-wrapper">
			<router-link class="nav-item" to="/footprint">
				<div class="navigation-item"></div>
				Footprint
			</router-link>
			<router-link class="nav-item" to="/aspect">
				<div class="navigation-item"></div>
				Aspect
			</router-link>
			<router-link class="nav-item" to="/retrograde">
				<div class="navigation-item"></div>
				Retrograde
			</router-link>
			<router-link class="nav-item" to="/discovery">
				<div class="navigation-item"></div>
				Discovery
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: "MainView"
}
</script>

<style scoped lang="scss">

.main-navigation-wrapper {

	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	.nav-item {
		margin-right: 20px;
		margin-bottom: 20px;
		text-align: center;
	}

	.navigation-item {
		padding: 25px;
		border-radius: 16px;
		border: 1px solid #fff;
		max-width: 120px;
		width: 120px;
		margin: 0 auto;
		height: 120px;
		background-color: white;
		transition: .4s ease all;
		margin-bottom: 15px;

		&:hover {
			background: #404E6E;
		}
	}

}


</style>
